<template>
  <div>
    <DeleteModal modal-id="modal-delete" @deleteToggle="deleteItem" />
    <b-modal
      id="modal-set-surgery-price"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="$t('surgery.set-surgery-price')"
      @ok="submitSetSurgeryPrice()"
    >
      <b-card-text>
        <b-row>
          <b-col lg="6">
            <b-form-group
              :label="$t('reception.Surgery Price')"
              label-for="Amount"
            >
              <b-form-input
                id="Amount"
                v-model="surgeryPrice.price"
                type="number"
                :placeholder="$t('reception.Surgery Price')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              :label="$t('reception.Surgery Discount')"
              label-for="Amount"
            >
              <b-form-input
                id="Amount"
                v-model="surgeryPrice.surgery_discount"
                type="number"
                :placeholder="$t('reception.Surgery Discount')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="12">
            <b-row v-for="(item, i) in surgeryPrice.doctors" :key="item.id">
              <b-col lg="6" class="px-2 d-flex align-items-center">
                <h3>
                  {{ $t("surgery.Doctor") }} :
                  {{ surgeryPrice.doctors[i].name || "" }}
                </h3>
              </b-col>
              <b-col lg="6">
                <b-form-group :label="$t('reception.Doctor Discount')">
                  <b-form-input
                    v-model="surgeryPrice.doctors[i].doctor_discount"
                    type="number"
                    :placeholder="$t('reception.Doctor Discount')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-modal
      :id="`modal-pay-doctor`"
      :no-close-on-backdrop="true"
      :title="$t('surgery.pay-doctor')"
      ok-only
      centered
      size="lg"
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payDoctorPrice()"
    >
      <b-card-text>
        <b-row>
          <b-col lg="12">
            <b-row
              v-for="(item, i) in payDoctorDataPost.doctors"
              :key="item.id"
            >
              <b-col lg="6" class="px-2 d-flex align-items-center">
                <h3>
                  {{ $t("surgery.pay-doctor") }} :
                  {{ payDoctorDataPost.doctors[i].name || "" }}
                </h3>
              </b-col>
              <b-col lg="6">
                <b-form-checkbox
                  :id="item.doctor_id"
                  v-model="payDoctorDataPost.doctors[i].isSelected"
                  name="checkbox-1"
                >
                  {{ $t("surgery.pay for this doctor") }}
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card no-body class="compact-card main-padding">
      <div class="compact-container">
        <b-row class="compact-row">
          <b-col
            md="12"
            class="d-flex justify-content-between align-items-center compact-header"
          >
            <h2 class="mb-0 compact-title">
              {{ $t("surgery.surgery-patient-history") }}
            </h2>
            <div class="view-toggle-buttons">
              <b-button-group size="sm">
                <b-button
                  :variant="
                    viewMode === 'cards' ? 'primary' : 'outline-primary'
                  "
                  size="sm"
                  @click="viewMode = 'cards'"
                >
                  <feather-icon icon="GridIcon" size="14" />
                  {{ $t("common.card_view") }}
                </b-button>
                <b-button
                  :variant="viewMode === 'list' ? 'primary' : 'outline-primary'"
                  size="sm"
                  @click="viewMode = 'list'"
                >
                  <feather-icon icon="ListIcon" size="14" />
                  {{ $t("common.list_view") }}
                </b-button>
              </b-button-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="compact-row compact-filters">
          <b-col md="3" cols="12" class="compact-col">
            <b-form-group
              :label="$t('common.name')"
              label-for="Name"
              class="compact-form-group"
            >
              <b-form-input
                id="Name"
                v-model="surgeryName"
                :placeholder="$t('common.name')"
                class="compact-input"
              />
            </b-form-group>
          </b-col>
          <b-col md="3" cols="12" class="compact-col">
            <AutoComplete
              v-model="surgery_id"
              :label="$t('surgery.surgery')"
              :serializer="(val) => val.id"
              param-query="search"
              endpoint="surgery"
              text-title="title"
            />
          </b-col>
          <b-col md="3" cols="12" class="compact-col">
            <b-form-group
              :label="$t('common.date')"
              label-for="surgery_date"
              class="compact-form-group"
            >
              <datepicker
                id="surgery_date"
                v-model="surgery_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2 compact-input"
                placeholder="YYYY-MM-DD"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="compact-content-row">
          <b-col>
            <!-- List View -->
            <b-table
              v-if="viewMode === 'list' && !loading"
              :items="data"
              responsive
              :fields="tableColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative compact-table"
            >
              <!-- has_sub_surgery -->
              <template #cell(title)="data">
                <div class="text-nowrap">
                  {{ data.item.patient_card.patient.name || "" }}
                </div>
              </template>
              <!-- <template #cell(has_sub_surgery)="data">
            <div class="text-nowrap">
              <span
                style="font-weight: bold; color: green"
                v-if="data.item.sub_surgeries.length"
                >{{ $t("common.yes") }}</span
              >
              <span v-else style="font-weight: bold; color: red">
                {{ $t("common.no") }}</span
              >
            </div>
          </template>
          <template #cell(is_sub_surgery)="data">
            <div class="text-nowrap">
              <span
                style="font-weight: bold; color: green"
                v-if="data.item.parent_id"
                >{{ $t("common.yes") }}</span
              >
              <span v-else style="font-weight: bold; color: red">
                {{ $t("common.no") }}</span
              >
            </div>
          </template> -->
              <template #cell(money_collected)="data">
                <div class="text-nowrap">
                  <span
                    v-if="data.item.money_collected === 1"
                    style="font-weight: bold; color: green"
                    >{{ $t("common.yes") }}</span
                  >
                  <span v-else style="font-weight: bold; color: red">
                    {{ $t("common.no") }}</span
                  >
                </div>
              </template>
              <!-- money_collected -->
              <template #cell(type)="data">
                <div class="text-nowrap">
                  {{ data.item.surgery.title }}
                </div>
              </template>
              <template #cell(doctors)="data">
                <div
                  v-if="data.item.doctors.length"
                  class="text-nowrap d-flex flex-warp"
                >
                  <div v-for="doctor in data.item.doctors" :key="doctor.id">
                    {{ doctor.name || "" }} -
                  </div>
                </div>
              </template>
              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <div class="text-nowrap">
                  <!-- @click="printId(data.item.id)" -->

                  <b-button
                    v-if="$store.state.app.permissions.includes('get-surgery')"
                    pill
                    size="sm"
                    variant="outline-warning"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'patient-surgery-info',
                        params: { id: data.item.id },
                      })
                    "
                  >
                    {{ $t("surgery.preview-update-surgery") }}
                  </b-button>
                  <b-button
                    v-if="false"
                    :disabled="
                      !$store.state.auth.permissions.includes(
                        'assign-permission-to-user'
                      )
                    "
                    pill
                    size="sm"
                    variant="outline-danger"
                    class="mb-75 mx-1"
                    @click="showDeleteModal(data.item)"
                  >
                    {{ $t("common.delete") }}
                  </b-button>
                </div>
              </template>
            </b-table>

            <!-- Card View -->
            <div
              v-else-if="viewMode === 'cards' && !loading"
              class="surgery-cards-container"
            >
              <!-- Empty State Placeholder -->
              <div v-if="data.length === 0" class="empty-state-card">
                <b-card class="text-center empty-placeholder-card">
                  <div class="empty-state-content">
                    <feather-icon
                      icon="FileTextIcon"
                      size="48"
                      class="empty-icon"
                    />
                    <h5 class="mt-2 mb-1">
                      {{ $t("common.no-results") }}
                    </h5>
                    <p class="text-muted mb-0">
                      <span v-if="surgery_date">
                        {{ $t("common.no-data-for-date") }}:
                        {{ formatDate(surgery_date) }}
                      </span>
                      <span v-else>
                        {{ $t("common.no-matching-results-found") }}
                      </span>
                    </p>
                  </div>
                </b-card>
              </div>
              <!-- Surgery Cards -->
              <b-row v-else>
                <b-col
                  v-for="surgery in data"
                  :key="surgery.id"
                  cols="12"
                  md="6"
                  lg="4"
                  class="compact-card-col"
                >
                  <b-card
                    class="surgery-card h-100 compact-surgery-card"
                    :class="{
                      'clickable-card':
                        $store.state.app.permissions.includes('get-surgery'),
                    }"
                    @click="
                      $store.state.app.permissions.includes('get-surgery') &&
                        $router.push({
                          name: 'patient-surgery-info',
                          params: { id: surgery.id },
                        })
                    "
                  >
                    <b-card-body class="compact-card-body">
                      <div class="compact-card-header">
                        <div
                          class="d-flex justify-content-between align-items-start mb-1"
                        >
                          <h6
                            class="mb-0 font-weight-bold text-primary compact-surgery-name"
                          >
                            {{ surgery.patient_card.patient.name || "" }}
                          </h6>
                          <b-badge
                            :variant="
                              surgery.type === 'Emergency'
                                ? 'danger'
                                : 'primary'
                            "
                            class="compact-badge"
                          >
                            {{ surgery.type }}
                          </b-badge>
                        </div>
                      </div>

                      <div class="surgery-info-item compact-info-item">
                        <span class="info-label"
                          >{{ $t("surgery.surgery") }}:</span
                        >
                        <span class="info-value">{{
                          surgery.surgery.title
                        }}</span>
                      </div>

                      <div class="surgery-info-item compact-info-item">
                        <span class="info-label"
                          >{{ $t("surgery.surgery_date_time") }}:</span
                        >
                        <span class="info-value">{{
                          formatSurgeryDate(
                            surgery.surgery_date_time || surgery.date
                          )
                        }}</span>
                      </div>

                      <div
                        v-if="surgery.surgeries_names"
                        class="surgery-info-item compact-info-item"
                      >
                        <span class="info-label"
                          >{{ $t("surgery.procedure") }}:</span
                        >
                        <span class="info-value">{{
                          surgery.surgeries_names
                        }}</span>
                      </div>

                      <div
                        v-if="surgery.doctors && surgery.doctors.length"
                        class="surgery-info-item compact-info-item"
                      >
                        <span class="info-label"
                          >{{ $t("surgery.Doctor") }}:</span
                        >
                        <span class="info-value">
                          <span
                            v-for="(doctor, index) in surgery.doctors"
                            :key="doctor.id"
                          >
                            {{ doctor.name || ""
                            }}<span v-if="index < surgery.doctors.length - 1"
                              >,
                            </span>
                          </span>
                        </span>
                      </div>

                      <div class="surgery-info-item compact-info-item">
                        <span class="info-label"
                          >{{ $t("surgery.is_money_collected") }}:</span
                        >
                        <b-badge
                          :variant="
                            surgery.money_collected === 1
                              ? 'light-success'
                              : 'light-danger'
                          "
                          class="compact-badge"
                        >
                          {{
                            surgery.money_collected === 1
                              ? $t("common.yes")
                              : $t("common.no")
                          }}
                        </b-badge>
                      </div>

                      <div class="compact-card-footer">
                        <b-button
                          v-if="
                            $store.state.app.permissions.includes('get-surgery')
                          "
                          variant="outline-warning"
                          size="sm"
                          class="compact-action-button"
                          @click.stop="
                            $router.push({
                              name: 'patient-surgery-info',
                              params: { id: surgery.id },
                            })
                          "
                        >
                          <feather-icon icon="EditIcon" size="14" />
                          {{ $t("surgery.preview-update-surgery") }}
                        </b-button>
                        <b-button
                          v-if="false"
                          :disabled="
                            !$store.state.auth.permissions.includes(
                              'assign-permission-to-user'
                            )
                          "
                          variant="outline-danger"
                          size="sm"
                          class="compact-action-button"
                          @click.stop="showDeleteModal(surgery)"
                        >
                          <feather-icon icon="TrashIcon" size="14" />
                          {{ $t("common.delete") }}
                        </b-button>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </div>

            <!-- Loading State -->
            <div v-if="loading" class="text-center compact-loading">
              <b-spinner label="Loading..." />
              <p class="mt-1 text-muted compact-loading-text">
                {{ $t("common.loading") }}
              </p>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="dataCount > 0" class="compact-pagination">
        <b-row class="compact-pagination-row">
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start compact-pagination-info"
          >
            <span class="text-muted compact-pagination-text">
              {{ $t("common.showing") }} {{ (page - 1) * take + 1 }}
              {{ $t("common.to") }} {{ Math.min(page * take, dataCount) }}
              {{ $t("common.of") }} {{ dataCount }}
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="page"
              :total-rows="dataCount"
              :per-page="take"
              first-number
              last-number
              size="sm"
              class="mb-0 compact-pagination-controls"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="16" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="16" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormSelect,
  BLink,
  BFormCheckbox,
  BButtonGroup,
  BCardBody,
} from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import permissionChecker from "@/mixins/permissionChecker";
import vSelect from "vue-select";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Datepicker from "vuejs-datepicker";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");

export default {
  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormSelect,
    BLink,
    StatisticCardHorizontal,
    vSelect,
    AutoComplete,
    Datepicker,
    BButtonGroup,
    BCardBody,
  },
  mixins: [permissionChecker],
  data() {
    return {
      take: 10,
      loading: true,
      dataCount: 0,
      data: [],
      tableColumns: [
        { key: "title", sortable: true, label: this.$t("common.name") },
        // { key: "price", sortable: true, label: this.$t("common.price") },
        // {
        //   key: "total_discount",
        //   sortable: true,
        //   label: this.$t("surgery.total_discount"),
        // },
        // {
        //   key: "total_price_after_discount",
        //   sortable: true,
        //   label: this.$t("surgery.total_price_after_discount"),
        // },
        { key: "type", sortable: true, label: this.$t("common.type") },
        {
          key: "procedure",
          sortable: true,
          label: this.$t("surgery.procedure"),
        },
        {
          key: "doctors",
          sortable: true,
          label: this.$t("surgery.Doctor"),
        },
        {
          key: "surgery_date_time",
          sortable: true,
          label: this.$t("surgery.surgery_date_time"),
        },
        // {
        //   key: "has_sub_surgery",
        //   sortable: true,
        //   label: this.$t("surgery.has_sub_surgery"),
        // },
        // {
        //   key: "is_sub_surgery",
        //   sortable: true,
        //   label: this.$t("surgery.is_sub_surgery"),
        // },
        {
          key: "money_collected",
          sortable: true,
          label: this.$t("surgery.is_money_collected"),
        },
        {
          key: "actions",
          label: this.$t("common.actions"),
        },
      ],
      params: {
        form: {},
        path: "",
      },
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      surgery_set_price_id: "",
      surgeryPrice: {
        price: 0,
        surgery_discount: 0,
        doctors: [
          {
            id: "",
            doctor_discount: "",
            name: "",
          },
        ],
      },
      payDoctorData: {},
      payDoctorDataPost: {
        id: "",
        doctors: { doctor_id: "", name: "", isSelected: false },
      },
      deleteForm: null,
      surgeryName: "",
      surgery_id: "",
      surgery_date: new Date(),
      surgeyPrice: "",
      viewMode: localStorage.getItem("surgeryPatientHistoryView") || "cards",
      isMounted: false,
    };
  },
  watch: {
    page() {
      this.getSurgeryList();
    },
    surgery_date() {
      if (this.isMounted) {
        this.getSurgeryList();
      }
    },
    surgeryName() {
      if (this.isMounted) {
        this.getSurgeryList();
      }
    },
    surgery_id() {
      if (this.isMounted) {
        this.getSurgeryList();
      }
    },
    viewMode(newVal) {
      localStorage.setItem("surgeryPatientHistoryView", newVal);
    },
  },
  mounted() {
    this.getSurgeryList();
    this.isMounted = true;
  },
  methods: {
    showModal(item) {
      this.$bvModal.show("modal-pay-doctor");
      this.payDoctorData = item;
      this.payDoctorDataPost.doctors = item.doctors.map((doctor) => ({
        doctor_id: doctor.id,
        name: doctor.name || "",
        isSelected: false,
      }));
    },
    show(item) {
      this.surgery_set_price_id = item.id;
      this.surgeryPrice.price = item.surgery.price;
      this.surgeryPrice.doctors = item.doctors.map((doctor) => ({
        id: doctor.id,
        doctor_discount: 0,
        name: doctor.name || "",
      }));
      this.$bvModal.show("modal-set-surgery-price");
    },
    formatDate(wantedDate) {
      const date = new Date(wantedDate);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    formatSurgeryDate(dateValue) {
      if (!dateValue) return "-";
      try {
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) {
          // If it's not a valid date, return as is (might already be formatted)
          return dateValue;
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      } catch (error) {
        // If parsing fails, return the original value
        return dateValue || "-";
      }
    },

    async submitSetSurgeryPrice() {
      this.surgeryPrice.doctors = this.surgeryPrice.doctors.map((doctor) => ({
        id: doctor.id,
        doctor_discount: doctor.doctor_discount,
      }));
      (this.params.form = this.surgeryPrice),
        (this.params.path = `/patient-surgery/prices/${this.surgery_set_price_id}`),
        this.$store
          .dispatch("put", this.params)
          .then((response) => {
            this.$bvModal.hide("modal-set-surgery-price");
            this.getSurgeryList();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              Object.keys(error.response.data).forEach((item) => {
                this.errorForm[item] = error.response.data[item][0];
              });
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    async getSurgeryList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/patient-surgery?page=${this.page}&take=${this.take}&sort=-id&include=surgery,doctors`;

      if (this.surgeryName) {
        url += `&filter[patientCard.patient.name]=${this.surgeryName}`;
      }
      if (this.surgeyPrice) {
        url += `&filter[price]=${this.surgeyPrice}`;
      }
      if (this.surgery_date) {
        console.log(this.surgery_date);
        url += `&filter[created_at]=${this.formatDate(this.surgery_date)}`;
      }
      if (this.surgery_id) {
        url += `&filter[surgery_id]=${this.surgery_id}`;
      }
      await this.getList(url);
      this.dataCount = this.all_data.total;
      console.log("ahmedddd surgery", this.all_data);
      this.data = this.all_data.data;
      this.loading = false;
    },
    payDoctorPrice() {
      const isSelectAll = this.payDoctorDataPost.doctors.find(
        (x) => x.isSelected === false
      );
      if (!isSelectAll) {
        (this.params.form = ""),
          (this.params.path = `/patient-surgery/${this.payDoctorData.id}/payDoctor`),
          this.$store
            .dispatch("put", this.params)
            .then((response) => {
              this.getSurgeryList();
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "pay doctor",
                  variant: "success",
                  text: "Doctor has been paid successfully",
                },
              });
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (const item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        this.payDoctorDataPost.doctors.forEach((item) => {
          if (item.isSelected === true) {
            const data = { doctor_id: item.doctor_id };
            (this.params.form = data),
              (this.params.path = `/patient-surgery/${this.payDoctorData.id}/payDoctor`),
              this.$store
                .dispatch("put", this.params)
                .then((response) => {
                  this.getSurgeryList();
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "pay doctor",
                      variant: "success",
                      text: "Doctor has been paid successfully",
                    },
                  });
                })
                .catch((error) => {
                  if (error.response.status === 400) {
                    for (const item in error.response.data) {
                      this.$toast({
                        component: ToastificationContent,
                        position: "top-right",
                        props: {
                          title: "validation error",
                          variant: "danger",
                          text: error.response.data[item][0],
                        },
                      });
                    }
                  }
                });
          }
        });
      }
    },
    showDeleteModal(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/patient-surgery/${this.deleteForm.id}`)
        .then((response) => {
          this.getSurgeryList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "success",
              text: this.$t("common.deleted-successfully"),
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: this.$t("common.error-deleting"),
            },
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

// Compact styles - no margins/padding
.compact-card {
  margin: 0;
  border: none;
}

.main-padding {
  padding: 1rem;
}

.compact-container {
  padding: 0.5rem;
}

.compact-row {
  margin: 0;
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.compact-header {
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
}

.compact-title {
  margin: 0;
}

.compact-filters {
  margin-bottom: 0.5rem;
}

.compact-col {
  padding: 0.25rem;
}

.compact-form-group {
  margin-bottom: 0.5rem;

  ::v-deep label {
    margin-bottom: 0.25rem;
  }
}

.compact-input {
  font-size: 0.875rem;
}

.compact-content-row {
  margin: 0.5rem 0;
}

.view-toggle-buttons {
  display: flex;
  align-items: center;
}

// Compact table
.compact-table {
  margin: 0;

  ::v-deep th,
  ::v-deep td {
    padding: 0.5rem 0.75rem;
  }

  ::v-deep thead th {
    font-weight: 600;
    padding: 0.5rem 0.75rem;
  }
}

// Surgery card view styles - compact
.surgery-cards-container {
  min-height: 150px;
  margin: 0;
}

.compact-card-col {
  padding: 0.25rem;
  margin: 0;
}

.compact-surgery-card {
  border: 1px solid #e0e0e0;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin: 0;
  padding: 0.5rem;
  cursor: default;

  &.clickable-card {
    cursor: pointer;

    &:hover {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
      border-color: #7367f0;
    }
  }

  .compact-card-header {
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .compact-surgery-name {
    margin: 0;
  }

  .compact-card-body {
    padding: 0.5rem 0;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .compact-card-footer {
    border-top: 1px solid #f0f0f0;
    padding-top: 0.5rem;
    margin-top: auto;
    display: flex;
    gap: 0.5rem;
  }

  .surgery-info-item {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
    gap: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }

    .info-label {
      font-weight: 600;
      color: #666;
      margin-bottom: 0.15rem;
    }

    .info-value {
      color: #333;
      word-break: break-word;
    }
  }

  .compact-badge {
    font-size: 0.75rem;
  }

  .compact-action-button {
    flex: 1;
    font-size: 0.8rem;
    padding: 0.375rem;
  }
}

// Empty state placeholder
.empty-state-card {
  padding: 2rem 1rem;
}

.empty-placeholder-card {
  border: 2px dashed #e0e0e0;
  background-color: #f8f9fa;
  padding: 3rem 2rem;
}

.empty-state-content {
  .empty-icon {
    color: #adb5bd;
    margin-bottom: 1rem;
  }
}

.compact-loading {
  padding: 1rem 0;
}

.compact-loading-text {
  margin: 0.5rem 0 0 0;
}

.compact-pagination {
  padding: 0.5rem;
  margin: 0;
}

.compact-pagination-row {
  margin: 0;
}

.compact-pagination-info {
  padding: 0.25rem;
}

.compact-pagination-text {
  font-size: 0.8rem;
}

.compact-pagination-controls {
  ::v-deep .page-link {
    padding: 0.25rem 0.5rem;
    font-size: 0.8rem;
  }

  ::v-deep .page-item {
    margin: 0 0.1rem;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
